import { cdnApi } from '@/helpers/api'
import { useAsyncState } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

interface IGuideItem {
  thumbnail: string
  name: string
  id: number
  youtubeId?: string
}
interface IGuideCategory {
  name: string
  id: number
  Children: [IGuideItem]
}

export const useMapleGuideStore = defineStore('MapleGuide', () => {
  const route = useRoute()
  const { state: Categories, isLoading } = useAsyncState(
    cdnApi.get('/ms-guides').then(({ data }) => data as IGuideCategory[]),
    [] as IGuideCategory[]
  )
  const CategoryNames = computed(() => [
    'all',
    ...(Categories.value.some((x) => x.Children.some((c) => c.youtubeId)) ? ['videos'] : []),
    ...Categories.value.map((x) => x.name),
  ])
  const currentCategory = computed(() => (route.params.category?.toString() ?? 'all').toLowerCase()) // fallback to all category
  const currentGuides = computed(() =>
    currentCategory.value === 'all'
      ? Categories.value.reduce((accum, cur) => accum.concat(cur.Children), [] as IGuideItem[])
      : currentCategory.value === 'videos'
      ? Categories.value.reduce(
          (accum, cur) => accum.concat(cur.Children.filter((x) => !!x.youtubeId)),
          [] as IGuideItem[]
        )
      : Categories.value.find((x) => x.name.toLowerCase() === currentCategory.value)?.Children ?? []
  )

  return {
    Categories,
    CategoryNames,
    currentCategory,
    currentGuides,
    isLoading,
  }
})
